module.exports = __webpack_public_path__ + "img/76242.0b930735.svg";